import styled from 'styled-components';

export const CommunicationsDrawerWrapper = styled.span`
  .communications-drawer-button {
    border-radius: 5px;
    width: 40px;
    height: 40px;
    margin: 0 5px;
    font-size: 20px;
  }
`;
